import { useState } from 'react';
import { Link, useLocation, Outlet, useNavigate } from 'react-router-dom';
import { Receipt, Tag, MessageCircle, BookOpen, Settings, ChevronLeft, KeyRound, PanelBottom } from 'lucide-react';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import logo from '../../assets/images/logos.png';

const menuItems = [
  { href: '/admin/chi-phi', icon: Receipt, label: 'Chi Phí' },
  { href: '/admin/phi-co-dinh', icon: Tag, label: 'Phí Cố Định' },
  { href: '/admin/tu-van', icon: MessageCircle, label: 'Quản lý Tư vấn' },
  { href: '/admin/ebook', icon: BookOpen, label: 'Quản lý Ebook' },
  { href: '/admin/settings', icon: Settings, label: 'Cài Đặt' },
  { href: '/admin/footer', icon: PanelBottom, label: 'Footer' },
  { href: '/admin/doi-mat-khau', icon: KeyRound, label: 'Đổi mật khẩu' },
];

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAdminAuth();

  const isActive = (href: string) => location.pathname.startsWith(href);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const activeLabel = menuItems.find((item) => isActive(item.href))?.label || 'Admin';

  return (
    <div className="admin-layout">
      <aside className={`admin-sidebar${collapsed ? ' collapsed' : ''}`}>
        <div className="admin-sidebar-head">
          {!collapsed && (
            <Link to="/admin/chi-phi" className="admin-logo">
              <img src={logo} alt="TUKI GROUP" />
            </Link>
          )}
          <button className="admin-collapse-btn" onClick={() => setCollapsed(!collapsed)} title="Thu/mở">
            <ChevronLeft size={20} style={{ transform: collapsed ? 'rotate(180deg)' : 'none' }} />
          </button>
        </div>

        <nav className="admin-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.href}
                to={item.href}
                className={`admin-nav-link${isActive(item.href) ? ' active' : ''}`}
                title={collapsed ? item.label : undefined}
              >
                <Icon size={20} />
                {!collapsed && <span>{item.label}</span>}
              </Link>
            );
          })}
        </nav>

        <div className="admin-sidebar-foot">
          <button
            className="admin-nav-link"
            style={{ width: '100%' }}
            onClick={handleLogout}
            title={collapsed ? 'Đăng xuất' : undefined}
          >
            <ChevronLeft size={20} style={{ transform: 'rotate(180deg)' }} />
            {!collapsed && <span>Đăng xuất</span>}
          </button>
        </div>
      </aside>

      <div className="admin-main">
        <header className="admin-header">
          <h1>{activeLabel}</h1>
          <div className="admin-user">
            <span className="admin-avatar">{(user?.username || 'A').charAt(0).toUpperCase()}</span>
            <span>{user?.username}</span>
          </div>
        </header>

        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
